import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { Separator } from '@doltech/ui/lib/figma/Layout/Landing/Content/Separator';
import { usePdfTrackingParams } from '@doltech/utils/lib/pdf';
import { getLandingUrlFromPath, mergeUrlWithParams } from '@doltech/utils/lib/url';
import { lowerCase } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

import iconSound from '../../view-test-subject/assets/audio-player.png';
import { ImageIcon } from '../../view-test-subject/ImageIcon';
import { TextWithLinkPdfOriginal } from '@doltech/ui/lib/figma/Layout/Landing/Content/TextWithLinkPdfOriginal';

const WORD_CONTAINER_WIDTH = 240;

const VocabItemPdfContainer = styled.div`
  display: grid;
  grid-template-columns: ${WORD_CONTAINER_WIDTH}px 1px minmax(0, 1fr);
  column-gap: 16px;
  background: ${colorsV2.gray5};
  border: 1px solid ${colorsV2.black10};
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  .word-container {
    width: ${WORD_CONTAINER_WIDTH}px;
  }

  .phonetics-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .ic-sound {
      margin-right: 12px;
    }
  }
`;

interface VocabExamplePDFProps {
  type?:
    | 'NOUN'
    | 'VERB'
    | 'ADV'
    | 'ADJ'
    | 'PREPOSITION'
    | 'CONJUNCTION'
    | 'ARTICLE'
    | 'INTERJECTION'
    | 'PRONOUN'
    | 'PHRASE';
  value?: string;
  example?: string;
  meaning?: string;
  pronounce?: string;
  pageUrl?: string; // vocab page url to refer in PDF
}

const IconImageOtherSound = () => <ImageIcon alt="Other sound" src={iconSound} />;

export const VocabExamplePDF = (props: VocabExamplePDFProps) => {
  const { value, type, pronounce, example, meaning, pageUrl } = props;
  const pronounText = pronounce?.startsWith('/') ? pronounce : `/${pronounce}/`;
  const pdfTrackingParams = usePdfTrackingParams();

  return (
    <VocabItemPdfContainer>
      <div className="word-container">
        <div className="vocab-phonetics">
          <Typography.Text variant="semi-bold/16">{value}</Typography.Text>{' '}
        </div>
        <div className="phonetics-container">
          <TextWithLinkPdfOriginal
            link={mergeUrlWithParams(getLandingUrlFromPath(pageUrl), pdfTrackingParams)}
            variant="semi-bold/16"
            content={
              <i className="ic-sound" role="button" aria-hidden="true">
                <IconImageOtherSound />
              </i>
            }
          />

          <Typography.Text className="phonetics-text" variant="regular/18-28">
            {pronounText}
          </Typography.Text>
        </div>
      </div>
      <Separator variant="vertical" backgroundColor={colorsV2.black20} />
      <div>
        <div>
          <Typography.Text variant="regular/16">
            ({lowerCase(type)}). {meaning}
          </Typography.Text>
          <div className="word-example-text">
            <Typography.Text variant="regular/14" style={{ color: colorsV2.black80 }}>
              {example}
            </Typography.Text>
          </div>
        </div>
      </div>
    </VocabItemPdfContainer>
  );
};
